module.exports = __webpack_public_path__ + "static/media/sort-ascending.3c60c5e6.svg";